import(/* webpackMode: "eager" */ "/home/runner/work/devpath-ai/devpath-ai/app/docs/page.tsx");
